module.exports = __webpack_public_path__ + "img/seats_2nd_row.12a22879.svg";